export default class TextToSpeechService {
/** @ngInject **/
  constructor(
    $http,
    ngAuthSettings,
    utils
  ) {
    this.$http = $http;
    this.ngAuthSettings = ngAuthSettings;
    this.utils = utils;
  }

  // will add other providers as needed
  getAvailableVoices(accountId) {
    const url = this._serviceBaseUrl(accountId) + '/voices';
    return this.$http.get(url);
  }
  
  // returns an Id for the saved recording and a presigned temp URL
  convertTextToSpeech(accountId, voiceId, providerId, text) {
    const url = this._serviceBaseUrl(accountId) + '/convert-text-to-speech';
    const data = {
      text,
      voiceId,
      providerId
    };
    return this.$http.post(url, data);
  }

  _serviceBaseUrl(accountId) {
    return this.ngAuthSettings.apiServiceBaseUri + accountId + '/texttospeech';
  }
}